import { createFileRoute } from "@tanstack/react-router";

/* eslint-disable-next-line no-restricted-imports */
import { IntercomProvider } from "react-use-intercom";

import DeleteAccountConfirmation from "./-components/DeleteAccountConfirmation";
import { INTERCOM_APP_ID } from "@/config/constants";

export const Route = createFileRoute("/_app/profile/deleteaccount/deleted")({
  component: DeleteAccountDeleted,
});

/**
 * Not a child of `_dashboard`: the account is gone, so there is no dashboard to
 * frame it with. The provider has to sit above the page, which calls
 * `useIntercom().shutdown` to end the account's Intercom session.
 *
 * `IntercomProvider` rather than `@/hooks/useIntercom`, which is the hook only —
 * the same exemption `IntercomProviderInternal` takes.
 */
function DeleteAccountDeleted() {
  return (
    <IntercomProvider
      appId={INTERCOM_APP_ID}
      autoBoot
      autoBootProps={{
        hideDefaultLauncher: true,
      }}
    >
      <DeleteAccountConfirmation />
    </IntercomProvider>
  );
}
